import { render } from "./GridTabParteneriComercial.vue?vue&type=template&id=0a528d6c&scoped=true&ts=true"
import script from "./GridTabParteneriComercial.vue?vue&type=script&lang=ts"
export * from "./GridTabParteneriComercial.vue?vue&type=script&lang=ts"

import "./GridTabParteneriComercial.vue?vue&type=style&index=0&id=0a528d6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a528d6c"]])

export default __exports__